export enum MenuComponent {
  AdditionalOptionsDoorsWindows = 'additional-options-doors-windows',
  AdditionalOptionsSectionsProps = 'additional-options-sections-props',
  Base = 'base',
  Brace = 'brace',
  CenterSectionCeiling = 'center-section-ceiling',
  CenterSectionLegFootprint = 'center-section-leg-footprint',
  CenterSectionWallsProperties = 'center-section-walls-properties',
  Colors = 'colors',
  ComponentSelector = 'component-selector',
  Depth = 'depth',
  FrameSpacing = 'frame-spacing',
  IconRadioStyle = 'icon-radio-style',
  IconRadioStyleGroup = 'icon-radio-style-group',
  IconRadioStyleVariation = 'icon-radio-style-variation',
  InstallationSurface = 'installation-surface',
  JTrim = 'j-trim',
  LeftLeanProps = 'left-lean-props',
  Leg = 'leg',
  Length = 'length',
  LoafingShed = 'loafing-shed',
  NoComponent = 'no-component',
  Porch = 'porch',
  PorchDepth = 'porch-depth',
  PorchLength = 'porch-length',
  PorchRailing = 'porch-railing',
  PorchSidewallDepth = 'porch-sidewall-depth',
  RightLeanProps = 'right-lean-props',
  RoofExtension = 'roof-extension',
  RoofOverhang = 'roof-overhang',
  RoofPitch = 'roof-pitch',
  RoofSnoop = 'roof-snoop',
  Roofing = 'roofing',
  SectionCupola = 'section-cupola',
  SectionCupolaQuantity = 'section-cupola-quantity',
  SectionEndWallRoofOverhang = 'section-end-wall-roof-overhang',
  SectionSelector = 'section-selector',
  SectionSelectorHideDisabled = 'section-selector-hide-disabled',
  SectionSelectorLeansOnly = 'section-selector-leans-only',
  SectionSideWallRoofOverhang = 'section-side-wall-roof-overhang',
  SectionStorageSelector = 'section-storage-selector',
  SelectedSectionBackWraparound = 'selected-section-back-wraparound',
  SelectedSectionBrace = 'selected-section-brace', // FIXME: rename SelectedSection... to Section...
  SelectedSectionCeiling = 'selected-section-ceiling',
  SelectedSectionDormer = 'selected-section-dormer',
  SelectedSectionDormerWithQuantity = 'selected-section-dormer-quantity',
  SelectedSectionFrontWraparound = 'selected-section-front-wraparound',
  SelectedSectionLeanType = 'selected-section-lean-type',
  SelectedSectionLeg = 'selected-section-leg',
  SelectedSectionLegFootprint = 'selected-section-leg-footprint',
  SelectedSectionRoofPitch = 'selected-section-roof-pitch',
  SelectedSectionSidesEnds = 'selected-section-sides-ends',
  SelectedSectionWallsProperties = 'selected-section-walls-properties',
  SelectedSectionWindBracing = 'selected-section-wind-bracing',
  SidewallHeight = 'sidewall-height',
  Siding = 'siding',
  SidingGroup = 'siding-group',
  Size = 'size',
  SizesByRoofPitchGroup = 'sizes-by-roof-pitch-group',
  SkylightOptions = 'skylight-options', // IFS-only so far,
  Storage = 'storage',
  Style = 'style',
  StyleAdditionalOptions = 'style-additional-options',
  StyleGroup = 'style-group',
  Trim = 'trim',
  TrimPackage = 'trim-package',
  Truss = 'truss',
}
